// extracted by mini-css-extract-plugin
var _1 = "OfferDisclaimer-module__offerDisclaimer--I7qtG";
var _2 = "OfferDisclaimer-module__section--CODnJ";
export { _1 as "offerDisclaimer", _2 as "section" }
